export const ActionTypes = {
  SET_PARTNER_CURRENCY: 'SET_PARTNER_CURRENCY',
  SET_PARTNER_SOCIAL_MEDIA: 'SET_PARTNER_SOCIAL_MEDIA'
};
